import {FilterConfig} from '@softline/application';

export const filterConfig: FilterConfig = {
  properties: []
}
